// import times from 'lodash/times';
import range from 'lodash/range';
// import fill from 'lodash/fill';

import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Bangkok');

// const getAvailability = (availabilities, day) => {
//   if (!availabilities.some((availability) => moment(availability.date).isSame(day, 'day'))) return { status: 'ask' };
//   return availabilities.filter((a) => moment(a.date).isSame(day))[0];
// };

export function getCurrentMonth() {
  return moment().format('MMMM YYYY');
}

export function getNextMonth(month) {
  const queryMonth = month ? moment(month, 'MMMM YYYY') : moment();
  return queryMonth.add(1, 'month').format('MMMM YYYY');
}

export function getPrevMonth(month) {
  const queryMonth = month ? moment(month, 'MMMM YYYY') : moment();
  return queryMonth.add(-1, 'month').format('MMMM YYYY');
}

export function getDays(month) {
  const firstDay = moment(month, 'MMMM YYYY').startOf('month').startOf('day');
  const lastDay = moment(month, 'MMMM YYYY').endOf('month').startOf('day');
  const days = range(firstDay.day()).fill(false);
  let currentDay = firstDay;
  while (!currentDay.isAfter(lastDay)) {
    days.push(currentDay.toDate());
    currentDay = currentDay.add(1, 'day');
  }
  return days.concat(range(6 - lastDay.day()).fill(false));
}

// export function generateCalendar(month, trip, availabilities) {
//   let currentMonth = month;
//   if (!currentMonth) {
//     currentMonth = moment().format('MMMM YYYY');
//   }
//   const firstDay = moment(currentMonth, 'MMMM YYYY').startOf('month').startOf('day');
//   const lastDay = moment(currentMonth, 'MMMM YYYY').endOf('month').startOf('day');
//   let currentDay = firstDay;
//   const arr = new Array(firstDay.day());
//   const dates = arr.fill({});
//   while (!currentDay.isAfter(lastDay)) {
//     const day = {
//       day: currentDay.date(),
//       date: currentDay.toDate(),
//     };
//     let availability = {};
//     if (availabilities) {
//       availability = getAvailability(availabilities, currentDay);
//     }
//     if (currentDay.isSame(moment(), 'day')) {
//       day.today = true;
//     }
//     if (currentDay.isBefore(moment().startOf('day'))) {
//       day.passed = true;
//       day.status = 'n/a';
//     } else if (trip && trip.available_days && trip.available_days.length === 7 && !trip.available_days[currentDay.day()]) {
//       day.status = 'n/a';
//       day.tripNotOperate = true;
//     } else {
//       day.status = 'ask';
//       if (trip && trip.user_id && trip.user_id.available_days && trip.user_id.available_days.length === 7 && trip.user_id.available_days[currentDay.day()] !== 'default') {
//         day.status = trip.user_id.available_days[currentDay.day()];
//       }
//       if (availabilities) {
//         if (availability.booking_id) {
//           day.status = 'n/a';
//           day.booking_id = availability.booking_id;
//         } else if (availability.status !== 'ask') {
//           day.status = availability.status;
//         }
//       }
//       if (day.status === 'available' && trip && trip.hours_in_advance && moment().add(trip.hours_in_advance, 'hour').isAfter(currentDay)) {
//         day.status = 'ask';
//       }
//     }
//     // } else if (trip && trip.hours_in_advance && moment().add(trip.hours_in_advance, 'hour').isAfter(currentDay)) {
//     //   day.status = 'ask';
//     //   if (availability.booking_id || availability.status === 'n/a') {
//     //     day.status = 'n/a';
//     //     day.booking_id = availability.booking_id;
//     //   }
//     // } else if (availabilities) {
//     //   if (availability.booking_id) {
//     //     day.status = 'n/a';
//     //     day.booking_id = availability.booking_id;
//     //   } else {
//     //     day.status = availability.status;
//     //   }
//     // } else {
//     //   day.status = 'ask';
//     // }

//     dates.push(day);
//     currentDay = currentDay.add(1, 'day');
//   }
//   return {
//     prev: moment(currentMonth, 'MMMM YYYY').add(-1, 'month').format('MMMM YYYY'),
//     next: moment(currentMonth, 'MMMM YYYY').add(1, 'month').format('MMMM YYYY'),
//     current: currentMonth,
//     days: dates.concat(fill(new Array(7 - lastDay.day() - 1), {})),
//   };
// }

export function sortDate(dates) {
  return dates.sort((a, b) => moment(a).unix() - moment(b).unix());
}

export function findDate(dates, date) {
  if (!date) return -1;
  return dates.findIndex((eachDate) => moment(eachDate).isSame(date, 'day'));
}

export function toggleDate(dates, date) {
  const index = findDate(dates, date);
  return (index < 0) ? sortDate([...dates, date]) : dates.filter((d, i) => i !== index);
}

// export function get7(date) {
//   return sortDate(
//     times(7, (i) => moment(date).add(-i - 1, 'day').startOf('day').toDate())
//       .concat(
//         times(7, (i) => moment(date).add(i + 1, 'day').startOf('day').toDate())
//       )
//   )
//     .filter((filteringDate) => !moment(filteringDate).isBefore(moment()));
// }

export function convertUserAvailability(availabilities) {
  return availabilities.map((month) => ({
    month: month.current,
    availabilities: month.days
      .filter((day) => (
        !day.passed && !day.today && day.status !== 'ask' && !day.booking_id && !!day.date
      ))
      .map((day) => ({
        date: day.date,
        status: day.status,
      })),
  }));
}

export function getMYFormat(locale = 'en') {
  switch (locale) {
    case 'zh': return 'YYYY年 MMMM';
    case 'en': return 'MMMM YYYY';
    default: return 'MMMM YYYY';
  }
}
